module.exports = __webpack_public_path__ + "static/media/flash.ebfa1ebc.png";